export const PURCHASE = "Purchase";
export const REFINANCE_LIMITED = "RefiRateTermLimitedCO";
export const REFINANCE_CASHOUT = "RefiCashout";
export enum INPUT_TYPE {
    TEXT = "text",
    NUMBER = "number",
    EMAIL = "email",
    SELECT = "select",
    STRING = "string"
}

function getRateIds() {
    try {
        return JSON.parse(process.env.GATSBY_RATE_IDS);
    } catch (error) {
        console.error(`Failed to load well known Rate Ids, check the GATSBY_RATE_IDS format`, error);
        return {};
    }
}

export const {
    ID_FIRST_BUYER_RATE,
    ID_15YR_FHA_RATE,
    ID_30YR_FHA_RATE,
    ID_15YR_VA_RATE,
    ID_30YR_VA_RATE,
    ID_30YR_USDA_RATE,
    ID_15YR_JUMBO_RATE,
    ID_20YR_JUMBO_RATE,
    ID_30YR_JUMBO_RATE,
    ID_FTHB_40YR_FIXED_15YR_BALLOON_RATE,
    ID_FTHB_7_6_ARM_RATE,
} = getRateIds();

// Well-known Rate IDs

// Prod IDs
// ID_FIRST_BUYER_RATE  = 19;
// ID_15YR_FHA_RATE     = 91;
// ID_30YR_FHA_RATE     = 92;
// ID_15YR_VA_RATE      = 93;
// ID_30YR_VA_RATE      = 94;
// ID_30YR_USDA_RATE    = 90;
// ID_15YR_JUMBO_RATE   = 87;
// ID_20YR_JUMBO_RATE   = 88;
// ID_30YR_JUMBO_RATE   = 89;

// Dev/QA IDs
// ID_FIRST_BUYER_RATE  = 19;
// ID_15YR_FHA_RATE     = 1084;
// ID_30YR_FHA_RATE     = 1085;
// ID_15YR_VA_RATE      = 1086;
// ID_30YR_VA_RATE      = 1087;
// ID_30YR_USDA_RATE    = 1091;
// ID_15YR_JUMBO_RATE   = 1088;
// ID_20YR_JUMBO_RATE   = 1089;
// ID_30YR_JUMBO_RATE   = 1090;
